/* Spinningstickers: presentationslager ovanpå Rides variantväljare (v4).
   - Färg: dropdown (.ss-color) FÖRE <variant-selects>, styr de dolda färgradioknapparna.
   - Finish: Bold-stil tvåstegsväljare (.ss-finish) EFTER <variant-selects>, dvs. under
     Model Year och ovanför Kvantitet. Styr den dolda Finish-kontrollen.
   Byggs EN gång per variantväljare; uppdateras på plats vid ändringar.
   Temat byter ut <variant-selects> vid varje val (HTMLUpdateUtility.viewTransition:
   den nya sätts in före den gamla, den gamla göms och tas bort efter 500 ms) —
   därför slås den SYNLIGA variant-selects upp vid varje åtgärd.
   - Bild <-> färg (v5): färgbyte visar variantens bild direkt (utan att vänta på temats
     sektionshämtning), galleriets bilder förladdas, och bläddring/miniatyrklick i galleriet
     sätter färgväljaren till den färg bilden hör till.
   - Språk (v6): butiken översätter optionsnamn och -värden ("Color"/"Färg", "Gloss + Holo"/
     "Blankt + Holo"). Skriptet räknar internt på de ENGELSKA värdena ur produktens JSON utan
     språkprefix och kopplar dem till sidans översatta via position (option i, värde j är
     samma i alla språk). Det som visas och det som sätts i Rides kontroller är det lokala. */
(function () {
  var CDN = "https://cdn.shopify.com/s/files/1/1060/0123/6305/files/";
  /* Rutorna visas 92-130 px breda; originalen är upp till 84 kB styck. CDN:en skalar och väljer
     WebP/AVIF själv (2026-10-24, ~310 -> ~110 kB för de sex rutorna). */
  var STORLEK = "?width=300";
  /* Nya materialbilder 2026-10-04: samma motiv i alla sex, bara materialet skiljer
     (källa shopify/materials/v2/grid.png). Gamla filerna ligger kvar i Files. */
  var FOIL_IMG = {
    "Gloss": CDN + "ss-finish-gloss.jpg" + STORLEK,
    "Matt": CDN + "ss-finish-matt.jpg" + STORLEK,
    "Glitter": CDN + "ss-finish-glitter.jpg" + STORLEK,
    "Reflective": CDN + "ss-finish-reflective.jpg" + STORLEK
  };
  /* Reflective är ett basmaterial, inte en finish (Kenny 2026-10-22): det går inte att
     kombinera med Holo, och Matt/Glitter ovanpå har inte erbjudits. Variantnamnet i
     Shopify är fortfarande "Reflective" (= bas Reflective, finish Gloss), så ordrar,
     översättningar och produktionen påverkas inte. */
  var BASE_IMG = {
    "Gloss": CDN + "ss-bas-gloss.jpg" + STORLEK,
    "Holo": CDN + "ss-bas-holo.jpg" + STORLEK,
    "Reflective": CDN + "ss-finish-reflective.jpg" + STORLEK
  };
  /* Holo sist under Base (Filip 2026-11-04: "Holo skulle vara sist ... under base"). */
  var BASE_ORDER = ["Gloss", "Reflective", "Holo"];
  var FOIL_ORDER = ["Gloss", "Matt", "Glitter"];
  var SUFFIX = " + Holo";
  var REFL = "Reflective", REFL_SUFFIX = " + Reflective";
  var COLOR_OPTION = "Color";
  var CARET = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';
  var productData = null, productDataUrl = null, productTried = null;
  /* L: engelska <-> lokala optionsnamn/värden per position (null = samma, t.ex. på engelska) */
  var L = null;
  var LANG = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var TXT = {
    en: { base: "Base", finish: "Finish", std: "standard", mat: "About our materials" },
    sv: { base: "Bas", finish: "Finish", std: "standard", mat: "Om våra material" },
    fr: { base: "Base", finish: "Finition", std: "standard", mat: "Nos matériaux" },
    de: { base: "Basis", finish: "Oberfläche", std: "Standard", mat: "Über unsere Materialien" },
    es: { base: "Base", finish: "Acabado", std: "estándar", mat: "Sobre nuestros materiales" },
    it: { base: "Base", finish: "Finitura", std: "standard", mat: "I nostri materiali" },
    nl: { base: "Basis", finish: "Afwerking", std: "standaard", mat: "Over onze materialen" }
  }[LANG] || null;
  if (!TXT) TXT = { base: "Base", finish: "Finish", std: "standard", mat: "About our materials" };
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function optName(o) { return typeof o === "string" ? o : o.name; }
  function oi(enName) { return L ? L.names.indexOf(enName) : -1; }
  function locName(enName) { var i = oi(enName); return i < 0 ? enName : L.loc[i]; }
  function toEn(i, v) { return (L && i >= 0 && has(L.l2e[i], v)) ? L.l2e[i][v] : v; }
  function toLoc(i, v) { return (L && i >= 0 && has(L.e2l[i], v)) ? L.e2l[i][v] : v; }
  /* engelskt namn för ett lokalt optionsnamn (radionamn utan -N eller select-namn) */
  function enNameOf(loc) {
    if (!L) return loc;
    var i = L.loc.indexOf(loc);
    return i < 0 ? loc : L.names[i];
  }
  function buildL(en, loc) {
    L = { names: [], loc: [], e2l: [], l2e: [] };
    en.options.forEach(function (o, i) {
      var lo = (loc && loc.options && loc.options[i]) || o;
      var e2l = {}, l2e = {}, lv = lo.values || [];
      (o.values || []).forEach(function (v, j) {
        var x = lv[j] == null ? v : lv[j];
        e2l[v] = x; l2e[x] = v;
      });
      L.names.push(optName(o)); L.loc.push(optName(lo));
      L.e2l.push(e2l); L.l2e.push(l2e);
    });
  }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

  function visible(el) { return !!el && el.style.display !== "none"; }
  function isVS(el) { return !!el && el.tagName && el.tagName.toLowerCase() === "variant-selects"; }
  /* Den synliga variant-selects i samma behållare som wrap */
  function liveVS(wrap) {
    var p = wrap.parentNode;
    if (!p) return null;
    var kids = p.children;
    for (var i = 0; i < kids.length; i++) {
      if (isVS(kids[i]) && visible(kids[i])) return kids[i];
    }
    return null;
  }

  function parseVal(v) {
    v = (v || "").trim();
    if (v === REFL) return { foil: "Gloss", base: REFL };
    if (v.slice(-REFL_SUFFIX.length) === REFL_SUFFIX) return { foil: v.slice(0, -REFL_SUFFIX.length), base: REFL };
    return v.slice(-SUFFIX.length) === SUFFIX
      ? { foil: v.slice(0, -SUFFIX.length), base: "Holo" }
      : { foil: v, base: "Gloss" };
  }
  function compose(foil, base) {
    if (base === "Holo") return foil + SUFFIX;
    if (base === REFL) return foil === "Gloss" ? REFL : foil + REFL_SUFFIX;
    return foil;
  }

  /* Generisk kontroll för ett alternativ (select eller radiogrupp) */
  /* name = ENGELSKA optionsnamnet; values/current/set talar engelska */
  function findOption(vs, name) {
    var i = oi(name), ln = locName(name);
    var sel = Array.prototype.filter.call(vs.querySelectorAll("select"), function (s) {
      return s.name === "options[" + ln + "]";
    })[0];
    if (sel) {
      dolj(sel, name);
      return {
        values: Array.prototype.map.call(sel.options, function (o) { return toEn(i, o.value); }),
        current: function () { return toEn(i, sel.value); },
        set: function (v) {
          v = toLoc(i, v);
          if (sel.value !== v) {
            sel.value = v;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      };
    }
    var re = new RegExp("^" + esc(ln) + "(-\\d+)?$");
    var group = [];
    Array.prototype.forEach.call(vs.querySelectorAll('input[type="radio"]'), function (r) {
      if (re.test((r.name || "").trim())) group.push(r);
    });
    if (!group.length) return null;
    dolj(group[0], name);
    return {
      values: group.map(function (r) { return toEn(i, (r.value || "").trim()); }),
      current: function () {
        var c = group.filter(function (r) { return r.checked; })[0];
        return toEn(i, (c ? c.value : group[0].value).trim());
      },
      set: function (v) {
        v = toLoc(i, v);
        var t = group.filter(function (r) { return (r.value || "").trim() === v; })[0];
        if (t && !t.checked) t.click();
      }
    };
  }
  /* Rides egen kontroll för Color/Finish döljs (CSS gör det redan för kända språk) */
  function dolj(el, name) {
    if (name !== COLOR_OPTION && name !== "Finish") return;
    var c = el.closest(".product-form__input");
    if (c) c.classList.add("ss-native-dold");
  }
  function findFinish(vs) { return findOption(vs, "Finish"); }

  /* Produktens JSON på sidans språk och utan språkprefix (= butikens standardspråk, engelska).
     productData är alltid den engelska; L kopplar ihop dem. */
  function productUrls() {
    var p = location.pathname.replace(/\/$/, "");
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/").replace(/\/$/, "");
    var en = (root && p.indexOf(root + "/") === 0) ? p.slice(root.length) : p;
    return { loc: p + ".js", en: en + ".js" };
  }
  function getJSON(url) {
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; });
  }
  function loadProduct(cb) {
    try {
      var u = productUrls();
      if (productData && productDataUrl === u.en) return cb(productData);
      productTried = u.en;
      L = null;
      var klar = function (en) { productData = en; productDataUrl = u.en; cb(en); };
      Promise.all([getJSON(u.en), u.loc === u.en ? null : getJSON(u.loc)])
        .then(function (r) {
          var en = r[0], loc = r[1];
          if (en && en.options) buildL(en, loc || en);
          klar(en);
        })
        .catch(function () { klar(null); });   // bygg ändå, med sidans egna värden
    } catch (e) { cb(null); }
  }
  function otherSelections(vs) {
    var out = {};
    Array.prototype.forEach.call(vs.querySelectorAll('input[type="radio"]'), function (r) {
      if (!r.checked) return;
      var n = enNameOf((r.name || "").trim().replace(/-\d+$/, ""));
      if (n !== "Finish") out[n] = toEn(oi(n), (r.value || "").trim());
    });
    Array.prototype.forEach.call(vs.querySelectorAll("select"), function (s) {
      var m = (s.name || "").match(/^options\[(.+)\]$/);
      if (!m) return;
      var n = enNameOf(m[1]);
      if (n !== "Finish") out[n] = toEn(oi(n), s.value);
    });
    return out;
  }
  function priceMap(product, vs) {
    if (!product) return {};
    var names = optNames(product);
    var fi = names.indexOf("Finish");
    if (fi < 0) return {};
    var others = otherSelections(vs);
    var map = {};
    product.variants.forEach(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      var ok = names.every(function (name, i) {
        if (i === fi) return true;
        return !(name in others) || (opts[i] || "").trim() === others[name];
      });
      if (ok) map[(opts[fi] || "").trim()] = v.price;
    });
    return map;
  }
  /* Påslaget formateras i butikens aktiva valuta (Shopify.currency.active sätts av
     plattformen; SS_CURRENCY från theme.liquid som reserv). Hela belopp utan decimaler. */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || window.SS_CURRENCY || "EUR";
    var v = cents / 100, frac = Math.round(cents) % 100 === 0 ? 0 : 2;
    if (/^(SEK|NOK|DKK)$/.test(cur)) {
      return v.toFixed(frac).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " kr";
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en",
        { style: "currency", currency: cur, minimumFractionDigits: frac, maximumFractionDigits: frac }).format(v);
    } catch (e) { return v.toFixed(frac) + " " + cur; }
  }

  /* ---------------------------------------------------------- färg-dropdown */
  function buildColor(vs) {
    var ctl = findOption(vs, COLOR_OPTION);
    if (!ctl || ctl.values.length < 2) return;
    var wrap = document.createElement("div");
    wrap.className = "product-form__input product-form__input--dropdown ss-color";
    wrap.innerHTML = '<label class="form__label"></label><div class="select">' +
                     '<select class="select__select"></select>' + CARET + "</div>";
    wrap.querySelector("label").textContent = locName(COLOR_OPTION);
    var sel = wrap.querySelector("select"), ci = oi(COLOR_OPTION);
    ctl.values.forEach(function (v) {
      var o = document.createElement("option");
      o.value = v; o.textContent = toLoc(ci, v);   // värdet engelskt, texten lokal
      sel.appendChild(o);
    });
    sel.value = ctl.current();
    sel.addEventListener("change", function () {
      var t = liveVS(wrap);
      if (!t) return;
      var c = findOption(t, COLOR_OPTION);
      galleryDriven = 0;
      if (c) c.set(sel.value);
      showMediaForColor(sel.value, t);
    });
    wrap._sync = function () {
      var t = liveVS(wrap);
      if (!t) return;
      var c = findOption(t, COLOR_OPTION);
      if (c && sel.value !== c.current()) sel.value = c.current();
    };
    // Färgen ska alltid stå över hojväljaren (.ss-dod, ss-dod.js) om den redan ligger före variantväljaren
    var fore = vs;
    while (hasClass(fore.previousElementSibling, "ss-dod")) fore = fore.previousElementSibling;
    vs.parentNode.insertBefore(wrap, fore);
  }

  /* ---------------------------------------------------------- finish-kort */
  function buildFinish(vs) {
    var ctl = findFinish(vs);
    if (!ctl) return;
    var combos = ctl.values.map(parseVal);
    var bases = [];
    combos.forEach(function (c) { if (bases.indexOf(c.base) < 0) bases.push(c.base); });
    if (bases.length < 2 && combos.length < 2) return;
    bases.sort(function (a, b) {
      var x = BASE_ORDER.indexOf(a), y = BASE_ORDER.indexOf(b);
      return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
    });

    var state = parseVal(ctl.current());
    var wrap = document.createElement("div");
    wrap.className = "ss-finish";

    function foilsFor(base) {
      var f = combos.filter(function (c) { return c.base === base; })
                    .map(function (c) { return c.foil; });
      return FOIL_ORDER.filter(function (x) { return f.indexOf(x) >= 0; })
        .concat(f.filter(function (x) { return FOIL_ORDER.indexOf(x) < 0; }));
    }
    function setNative() {
      var t = liveVS(wrap);
      if (!t) return;
      var c = findFinish(t);
      if (c) c.set(compose(state.foil, state.base));
    }

    function group(title) {
      var g = document.createElement("div");
      g.className = "ss-group";
      g.innerHTML = '<div class="ss-group-title"></div><div class="ss-tiles"></div>';
      g.querySelector(".ss-group-title").textContent = title;
      return g;
    }
    var gBase = group(TXT.base);
    var gFoil = group(TXT.finish);
    var fi = oi("Finish");
    function shown(name) { return name === "Holo" ? name : toLoc(fi, name); }

    /* Skapa kort EN gång; uppdatera bara klasser/priser sen. */
    function makeTile(name, img, onClick) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ss-tile";
      b.dataset.value = name;
      b.innerHTML = '<img alt="" loading="lazy"><span class="ss-tile-name"></span>' +
                    '<span class="ss-tile-extra"></span>';
      b.querySelector("img").src = img || "";
      b.querySelector(".ss-tile-name").textContent = shown(name);
      b.title = name === "Gloss" ? shown(name) + " (" + TXT.std + ")" : shown(name);
      b.addEventListener("click", onClick);
      return b;
    }
    var baseTiles = {}, foilTiles = {};
    bases.forEach(function (b) {
      baseTiles[b] = makeTile(b, BASE_IMG[b], function () {
        if (state.base === b) return;
        state.base = b;
        var foils = foilsFor(b);
        if (foils.indexOf(state.foil) < 0) state.foil = foils[0];
        update(); setNative();
      });
      gBase.querySelector(".ss-tiles").appendChild(baseTiles[b]);
    });
    var allFoils = [];
    combos.forEach(function (c) { if (allFoils.indexOf(c.foil) < 0) allFoils.push(c.foil); });
    FOIL_ORDER.filter(function (x) { return allFoils.indexOf(x) >= 0; })
      .concat(allFoils.filter(function (x) { return FOIL_ORDER.indexOf(x) < 0; }))
      .forEach(function (f) {
        foilTiles[f] = makeTile(f, FOIL_IMG[f], function () {
          if (state.foil === f) return;
          state.foil = f;
          update(); setNative();
        });
        gFoil.querySelector(".ss-tiles").appendChild(foilTiles[f]);
      });

    var prices = {};
    /* Finns varianten för vald färg? (prices har bara befintliga varianter för
       aktuellt färg/års-val; Gold och Fluo Yellow finns t.ex. bara i Gloss) */
    function exists(foil, base) {
      var keys = Object.keys(prices);
      return !keys.length || compose(foil, base) in prices;
    }
    function update() {
      var foils = foilsFor(state.base);
      Object.keys(baseTiles).forEach(function (b) {
        var any = foilsFor(b).some(function (f) { return exists(f, b); });
        baseTiles[b].style.display = any ? "" : "none";
        baseTiles[b].classList.toggle("on", b === state.base);
        var extra = "";
        if (b !== "Gloss") {
          /* tillägget mot Gloss-bas med den finish som blir vald (Reflective har bara Gloss) */
          var f = exists(state.foil, b) && foilsFor(b).indexOf(state.foil) >= 0 ? state.foil
            : foilsFor(b).filter(function (x) { return exists(x, b); })[0];
          var d = prices[compose(f, b)] - prices[compose(f, "Gloss")];
          if (!isNaN(d) && d > 0) extra = "+" + money(d);
        }
        baseTiles[b].querySelector(".ss-tile-extra").textContent = extra;
      });
      var basePrice = prices[compose(foils[0], state.base)];
      Object.keys(foilTiles).forEach(function (f) {
        var vis = foils.indexOf(f) >= 0 && exists(f, state.base);
        foilTiles[f].style.display = vis ? "" : "none";
        foilTiles[f].classList.toggle("on", f === state.foil);
        var p = prices[compose(f, state.base)];
        var extra = "";
        if (vis && p != null && basePrice != null && p - basePrice > 0) {
          extra = "+" + money(p - basePrice);
        }
        foilTiles[f].querySelector(".ss-tile-extra").textContent = extra;
      });
    }
    function refreshPrices() {
      loadProduct(function (p) {
        var t = liveVS(wrap);
        prices = priceMap(p, t || vs);
        if (!exists(state.foil, state.base)) {
          /* valet finns inte för den här färgen: gå till första tillgängliga (Gloss först) */
          var b = bases.filter(function (x) {
            return foilsFor(x).some(function (f) { return exists(f, x); });
          })[0];
          if (b) {
            state.base = b;
            state.foil = foilsFor(b).filter(function (f) { return exists(f, b); })[0];
            setNative();
          }
        }
        update();
      });
    }

    /* Extern synk: temat har ritat om / annan option ändrad */
    wrap._sync = function () {
      var t = liveVS(wrap);
      if (!t) return;
      var c = findFinish(t);
      if (c) {
        var now = parseVal(c.current());
        state.base = now.base;
        state.foil = now.foil;
      }
      refreshPrices();
    };

    update();
    refreshPrices();
    if (bases.length > 1) wrap.appendChild(gBase);
    wrap.appendChild(gFoil);
    /* Länk till materialsidan (2026-10-09), rubrikerna där har samma namn som korten */
    var ml = document.createElement("a");
    ml.className = "ss-material-link";
    ml.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "pages/materials" + (bases.length > 1 ? "#premium-base" : "#premium-finish");
    ml.textContent = TXT.mat;
    wrap.appendChild(ml);
    vs.parentNode.insertBefore(wrap, vs.nextSibling);
  }

  /* ---------------------------------------------------------- bild <-> färg */
  function optNames(product) { return product.options.map(optName); }
  function variantOpts(v) { return [v.option1, v.option2, v.option3]; }
  /* Variant som matchar valen i sel (namn -> värde); saknas exakt träff räcker färgen */
  function variantFor(product, sel) {
    var names = optNames(product), best = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], o = variantOpts(v), all = true, colorOk = false;
      for (var j = 0; j < names.length; j++) {
        if (!(names[j] in sel)) continue;
        var hit = (o[j] || "").trim() === sel[names[j]];
        if (names[j] === COLOR_OPTION) colorOk = hit;
        if (!hit) all = false;
      }
      if (all) return v;
      if (colorOk && !best) best = v;
    }
    return best;
  }
  function mediaIdOf(v) { return v && v.featured_media ? String(v.featured_media.id) : null; }
  function colorForMedia(product, id) {
    var ci = optNames(product).indexOf(COLOR_OPTION);
    if (ci < 0) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (mediaIdOf(product.variants[i]) === id) return (variantOpts(product.variants[i])[ci] || "").trim();
    }
    return null;
  }
  function gallery() { return document.querySelector("media-gallery"); }
  function activeMediaId() {
    var g = gallery(), a = g && g.querySelector("[data-media-id].is-active");
    return a ? String(a.dataset.mediaId).split("-").pop() : null;
  }
  /* Visa bilden för vald färg direkt (temat byter själv igen efter sin hämtning) */
  function showMediaForColor(color, vs) {
    loadProduct(function (p) {
      var g = gallery();
      if (!p || !g || !g.setActiveMedia) return;
      var sel = vs ? otherSelections(vs) : {};
      sel[COLOR_OPTION] = color;
      var id = mediaIdOf(variantFor(p, sel));
      if (!id || id === activeMediaId()) return;
      var li = g.querySelector('[data-media-id$="-' + id + '"]');
      if (li) g.setActiveMedia(li.dataset.mediaId, true);
    });
  }
  /* Galleriet bläddrat/miniatyr klickad -> sätt färgen bilden hör till */
  var galleryTimer = null, galleryDriven = 0;
  function onGalleryMedia(id) {
    clearTimeout(galleryTimer);
    galleryTimer = setTimeout(function () {
      loadProduct(function (p) {
        var w = document.querySelector(".ss-color");
        if (!p || !w) return;
        var t = liveVS(w), c = t && findOption(t, COLOR_OPTION);
        if (!c) return;
        var cur = otherSelections(t);
        cur[COLOR_OPTION] = c.current();
        if (mediaIdOf(variantFor(p, cur)) === id) return;   // bilden hör redan till vald färg
        var col = colorForMedia(p, id);
        if (!col || col === c.current()) return;
        w.querySelector("select").value = col;
        galleryDriven = Date.now();
        c.set(col);
      });
    }, 80);
  }
  function watchGallery() {
    var g = gallery(), pi = document.querySelector("product-info");
    if (!g || g._ssWatched) return;
    /* Väntar tills Rides custom elements är uppgraderade (ensure körs igen vid DOM-ändringar
       och vid DOMContentLoaded, efter de deferred skripten) */
    if (typeof g.setActiveMedia !== "function" || !pi || typeof pi.updateMedia !== "function") return;
    g._ssWatched = true;
    /* Rides setActiveMedia flyttar bilden först och rullar dit mjukt (ser ut som en
       swipe tillbaka). Rulla i stället omedelbart till den aktiva bilden i samma tick. */
    var origSet = g.setActiveMedia;
    g.setActiveMedia = function (id) {
      var r = origSet.apply(this, arguments);
      var li = g.querySelector('[data-media-id="' + id + '"]');
      if (li && li.parentElement) {
        var ul = li.parentElement, prev = ul.style.scrollBehavior;
        ul.style.scrollBehavior = "auto";
        ul.scrollLeft = li.offsetLeft;
        ul.style.scrollBehavior = prev;
      }
      return r;
    };
    /* Kom färgbytet från galleriet (swipe/miniatyr) ska temat inte sortera om galleriet
       efter sin hämtning — bara markera bilden som redan visas. */
    if (!pi._ssPatched) {
      pi._ssPatched = true;
      var origUpd = pi.updateMedia;
      pi.updateMedia = function (html, mediaId) {
        if (mediaId && Date.now() - galleryDriven < 3000) {
          var g2 = this.querySelector("media-gallery");
          if (g2 && g2.setActiveMedia) g2.setActiveMedia(this.dataset.section + "-" + mediaId, false);
          return;
        }
        return origUpd.apply(this, arguments);
      };
    }
    /* Swipe på mobil sätter inte is-active i Ride — gör det här, så att alla vägar
       (swipe, miniatyr, temats variantbyte) går via samma is-active-bevakning. */
    var viewer = g.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener("slideChanged", function (e) {
        var el = e.detail && e.detail.currentElement;
        if (el && el.dataset && el.dataset.mediaId && !el.classList.contains("is-active")) {
          /* bara klassen — Rides setActiveMedia rullar också, vilket stör pågående swipe */
          Array.prototype.forEach.call(viewer.querySelectorAll("[data-media-id]"), function (x) {
            x.classList.remove("is-active");
          });
          el.classList.add("is-active");
        }
      });
    }
    var lastActive = activeMediaId();
    new MutationObserver(function () {
      var id = activeMediaId();
      if (id && id !== lastActive) { lastActive = id; onGalleryMedia(id); }
    }).observe(g, { attributes: true, attributeFilter: ["class"], subtree: true });
    /* Förladda galleriets bilder när sidan är klar, så färgbytet blir omedelbart */
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1200); };
    idle(function () {
      Array.prototype.forEach.call(g.querySelectorAll('.product__media-item img[loading="lazy"]'), function (img) {
        img.loading = "eager";
      });
    });
    loadProduct(function () {});
  }

  /* ---------------------------------------------------------- livscykel */
  function hasClass(el, c) { return !!(el && el.classList && el.classList.contains(c)); }
  function ensure() {
    watchGallery();
    var all = document.querySelectorAll("variant-selects");
    /* optionerna kan vara översatta: bygg först när engelska/lokala kopplingen finns
       (ett försök per produkt-URL; misslyckas det byggs det med sidans egna värden) */
    var u = all.length ? productUrls().en : null;
    if (u && productDataUrl !== u && productTried !== u) {
      loadProduct(function () { schedule(); });
      return;
    }
    if (u && productDataUrl !== u) return;   // hämtning pågår
    all.forEach(function (vs) {
      if (!visible(vs)) return;                   // gammal, på väg bort
      var p = vs.parentNode;
      if (!p) return;
      var prev = vs.previousElementSibling;
      while (hasClass(prev, "ss-dod")) prev = prev.previousElementSibling;   // hojväljaren ligger mellan färg och varianter
      if (!hasClass(prev, "ss-color")) buildColor(vs);
      // hoppa över gömda variant-selects mellan den nya och finish-wrappen
      var next = vs.nextElementSibling;
      while (isVS(next) && !visible(next)) next = next.nextElementSibling;
      if (!hasClass(next, "ss-finish")) buildFinish(vs);
    });
    // föräldralösa wrappar (mall bytt) tas bort
    Array.prototype.forEach.call(document.querySelectorAll(".ss-finish, .ss-color"), function (w) {
      if (!liveVS(w)) w.parentNode.removeChild(w);
    });
  }

  var raf = (typeof requestAnimationFrame === "function")
    ? requestAnimationFrame
    : function (f) { return setTimeout(f, 50); };
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    raf(function () {
      scheduled = false;
      ensure();
    });
  }
  var syncTimer = null;
  document.addEventListener("change", function (e) {
    // annan option ändrad (färg/år) → uppdatera priser/val i befintlig UI
    if (e.target && e.target.closest && e.target.closest("variant-selects")) {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        Array.prototype.forEach.call(document.querySelectorAll(".ss-finish, .ss-color"), function (w) {
          if (w._sync) w._sync();
        });
      }, 150);
    }
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensure);
  } else {
    ensure();
  }
  new MutationObserver(schedule)
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Inget hopp upp till bilden vid variantbyte (Filip 2026-10-05). Rides media-gallery.js
   gör window.scrollTo({top}) till den aktiva bilden när varianten byts och bilden ligger
   ovanför skärmen — besökaren som valde finish längre ner tappade sin plats. I 2,5 s efter
   att man rört finishkorten, färgen eller årsmodellen ignoreras just vertikala scrollTo
   med en top-angivelse. Galleriet byter fortfarande bild; bara sidhoppet stoppas. */
(function () {
  var las = 0, orig = window.scrollTo;
  function lås(e) {
    var t = e.target;
    if (t && t.closest && t.closest(".ss-finish, .ss-color, variant-selects, .product-form__input")) las = Date.now() + 2500;
  }
  document.addEventListener("click", lås, true);
  document.addEventListener("change", lås, true);
  window.scrollTo = function (a, b) {
    if (Date.now() < las && a && typeof a === "object" && typeof a.top === "number" && a.left === undefined) return;
    return orig.apply(window, arguments);
  };
})();
